angular.module('impactx.cube').directive('ixCubeMenuList', [function() {
    return {
        scope: {
            menuitem: "=",
            options: "="
        },
        controller: 'CubeMenuListCtrl',
        controllerAs: 'cubeMenuListCtrl',
        restrict: 'E',
        templateUrl: 'modules/cube/templates/cubesubmenu.tmpl.html'
    }
}]);